// extracted by mini-css-extract-plugin
module.exports = {"smallScreen":"320px","mediumScreen":"768px","main":"main_main__1rQiz","result":"main_result__1uoyU"};